var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIs = function SvgIs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 1800"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2500v1800H0",
    fill: "#003897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M700 0h400v1800H700M0 700h2500v400H0",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M800 0h200v1800H800M0 800h2500v200H0",
    fill: "#d72828"
  })));
};

export default SvgIs;